module.exports = __webpack_public_path__ + "static/media/icon.c09d9cc3.png";